import { Modules } from '../../util/modules'
import { RouteConfig } from 'vue-router'
import { paymentSettingsRouteNames } from '@/routes/constants/location'
import { requireAuthAndLocation } from '../auth'

const PaymentSettingsWrapper = () => import('@/pmd/pages/payments/settings/PaymentSettings.vue')

const PaymentReceiptSettings = () => import('@/pmd/pages/payments/settings/PaymentReceiptSettings.vue')

const PaymentTaxSettings = () => import('@/pmd/pages/payments/settings/TaxSettings.vue')

const PaymentSubscriptionSettings = () => import('@/pmd/pages/payments/settings/PaymentSubscriptionSettings.vue')

const EcommerceNotificationSettings = () => import('@/pmd/pages/payments/settings/EcommerceNotificationSettings.vue')

const StoreTeamNotificationSettings = () => import('@/pmd/pages/payments/settings/StoreTeamNotificationSettings.vue')

const StoreShippingSettings = () => import('@/pmd/pages/payments/settings/StoreShippingSettings.vue')

const StoreShippingOriginSettings = () => import('@/pmd/pages/payments/settings/StoreShippingOriginSettings.vue')

const MiscellaneousCharges = () => import('@/pmd/pages/payments/settings/MiscellaneousCharges.vue')

const PaymentLinksSettings = () =>
    import('@/pmd/pages/payments/settings/PaymentLinksSettings.vue')

export const PaymentsRoute: RouteConfig[] = [
  {
    path: 'payments/settings',
    name: paymentSettingsRouteNames.settings,
    component: PaymentSettingsWrapper,
    beforeEnter: requireAuthAndLocation,
    children: [
      {
        path: 'receipts',
        name: paymentSettingsRouteNames.settingsReceipts,
        component: PaymentReceiptSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'taxes',
        name: paymentSettingsRouteNames.settingsTaxes,
        component: PaymentTaxSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'notifications',
        name: paymentSettingsRouteNames.settingsNotifications,
        component: EcommerceNotificationSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'team-notifications',
        name: 'payment-settings-team-notifications',
        component: StoreTeamNotificationSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'shipping',
        name: paymentSettingsRouteNames.settingsShipping,
        component: StoreShippingSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'shipping-origin',
        name: 'payment-settings-shipping-origin',
        component: StoreShippingOriginSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
      {
        path: 'subscriptions',
        name: paymentSettingsRouteNames.settingsSubscriptions,
        component: PaymentSubscriptionSettings,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
            {
                path: 'payment-links',
                name: paymentSettingsRouteNames.settingsPaymentLinks,
                component: PaymentLinksSettings,
                beforeEnter: requireAuthAndLocation,
                meta: { translations: [Modules.Payments] },
            },
      {
        path: 'miscellaneous-charges',
        name: paymentSettingsRouteNames.settingsMiscellaneousCharges,
        component: MiscellaneousCharges,
        beforeEnter: requireAuthAndLocation,
        meta: { translations: [Modules.Payments] },
      },
    ],
  },
]
